import React from "react";
import PropTypes from "prop-types";

import Group from "./Apparatus/group/Group"

import { Pipette } from "./Apparatus/Pipette"
import { TipBox } from "./Apparatus/TipBox"
import { Trash } from "./Apparatus/Trash"

// PhotosynthesisComponents
import { Box } from "./Apparatus/Box"
import { CuvetteRack } from "./Apparatus/CuvetteRack"
import LidShelf from "./Apparatus/LidShelf/LidShelf";
import { Light } from "./Apparatus/Light"
import { ExperimentPoster } from "./Apparatus/ExperimentPoster";

import { Cuvette } from "./Apparatus/Cuvette"
import { CuvetteSeal } from "./Apparatus/CuvetteSeal"
import { GlassTube } from "./Apparatus/GlassTube"
import { PlantTank } from "./Apparatus/PlantTank"

import { BoxHolder } from "./Apparatus/BoxHolder"

import { Spectrophotometer } from "./Apparatus/Spectrophotometer"
import { Stopper } from "./Apparatus/Stopper"
import { Timer } from "./Apparatus/Timer"
import { Plant } from "./Apparatus/Plant"

import { Solution } from "./Apparatus/Solution"
import { Microcentrifuge } from "./Apparatus/Microcentrifuge"
import { IceBucket } from "./Apparatus/IceBucket"
import { PowerSupply } from "./Apparatus/powerSupply"

import { Flask } from "./Apparatus/flask"
import { PowerSupplyLead }  from "./Apparatus/powerSupplyLead"

import TubeStand from "./Apparatus/TubeStand/TubeStand"
import Shelf from "./Apparatus/Shelf/Shelf"
import { RotorAdapters } from "./Apparatus/RotorAdapters"
import Table from "./Apparatus/Table/Table"
import PipetteRack from "./Apparatus/PipetteRack/PipetteRack"

import "./style.scss";

export class ProtocolScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}

  doCompPart = data => {
    let groupArr = [];
    let compArr = [];

    Object.keys(data).forEach((key, index) => {
      compArr = [];
      data[key].components.forEach((comp, index) => {
        compArr.push(this.buildComponent(comp, index));
      });
      groupArr.push(
        <Group key={index} components={compArr} position={data[key].position} />
      );
    });

    return groupArr
  };

  buildComponent = (data, index) => {
    switch (data.component) {

      case "Pipette":
        return <Pipette defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Tip Box":
        return <TipBox defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Trash":
        return <Trash defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Box":
        return <Box defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Cuvette Rack":
        return <CuvetteRack defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Lid Shelf":
        return <LidShelf defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Light":
        return <Light defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Experiment Poster":
        return <ExperimentPoster defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Cuvette":
      return <Cuvette defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Cuvette Seal":
        return <CuvetteSeal defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Glass Tube":
        return <GlassTube defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Plant Tank":
        return <PlantTank defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Box Holder":
        return <BoxHolder defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Plant":
        return <Plant defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Spectrophotometer":
        return <Spectrophotometer defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Timer":
        return <Timer defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Stopper":
        return <Stopper defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Microcentrifuge":
        return <Microcentrifuge defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Ice Bucket":
        return <IceBucket defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      //case "Thermocycler":
        //return <Thermocycler defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Power Supply":
        return <PowerSupply  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Power Supply Lead":
        return <PowerSupplyLead  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} sceneScale={this.props.sceneScale} userScale={this.props.userScale} />;

      case "Flask":
      return <Flask  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Rotor Adapters":
        return <RotorAdapters defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;


    // case "Transilluminator":
    //   return <Transilluminator defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Solution":
        return <Solution defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;


      case "SolutionTwo":
        return <Solution defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      // case "Heat Block":
      //   return <HeatBlock defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      // case "Tube":
      //     return <Tubes key={index} pos={data.position} id={data.props.id} />;

      case "Table":
        return <Table key={index} pos={data.position} id={data.props.id} />;

      case "Shelf":
        return <Shelf key={index} pos={data.position} id={data.props.id} />;
      case "ShelfTwo":
        return <Shelf key={index} pos={data.position} id={data.props.id} />;

      case "Pipette Rack":
        return <PipetteRack key={index} pos={data.position} id={data.props.id} />;

      case "Tube Stand":
        return <TubeStand key={index} pos={data.position} id={data.props.id} />;

      case "Tube Stand Two":
        return <TubeStand key={index} pos={data.position} id={data.props.id} />;

      // case "Poster":
      //   return <Poster key={index} pos={data.position} id={data.props.id} />;

      default:
        break;
    }
  };

  render() {
    return this.doCompPart(this.props.apparatus);
  }
}

ProtocolScene.propTypes = {
  optionHolders: PropTypes.array.isRequired,
};
